import { API, authenticationService } from '@enkla-gui'
import React, { useContext, useEffect, useState } from 'react'
import { date, notify, useInterval } from '@/_helpers'


import { UserContext } from '@/App'
import { useHistory } from 'react-router-dom'
import { Drawer } from 'antd'

export default function User() {
  const history = useHistory()
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const [notificationsOpen, setNotificationsOpen] = useState(false)
  const [notifications, setNotifications] = useState([])
  const { user, billable } = useContext(UserContext)

  useInterval(async () => {
    fetchNotifications()
  }, 30000)

  useEffect(() => {
    fetchNotifications()
  }, [])

  const fetchNotifications = () => {
    API.get('api/auth/notifications').then(notifications => setNotifications(notifications))
  }

  const Logout = function() {
    authenticationService.logout()
    history.push('/login')
  }
  const markAsRead = (notification) => {
    if (notification.read_at === null) {
      API.post('api/auth/notification/' + notification.id + '/read')
      fetchNotifications()
    }
  }

  const clearNotification = (e, notification) => {
    e.stopPropagation()
    API.delete(`api/auth/notifications/${notification.id}`)
      .then(res => {
        fetchNotifications()
      })
      .catch(([err, res]) => {
        notify.toast(`Borttagningen misslyckades: ${res.message}`, 'error')
      })
  }

  const markAllAsRead = () => {
    API.post('api/auth/notifications/read')
      .then(res => {
        fetchNotifications()
      })
      .catch(([err, res]) => {
        notify.toast(`Misslyckades: ${res.message}`, 'error')
      })
  }

  const remove = async () => {
    if (!(await notify.confirm())) return
    API.delete(`api/auth/notifications`)
      .then(res => {
        notify.toast('Alla notiser rensade')
        setNotificationsOpen(false)
        setNotifications([])
      })
      .catch(([err, res]) => {
        notify.toast(`Borttagningen misslyckades: ${res.message}`, 'error')
      })
  }

  const getSubscription = () => {
    switch (user.billable?.membership) {
      case -1:
        return <span class='badge bg-danger'>Inget medlemsskap</span>
      case -2:
        return <span class='badge bg-success'>Medlem</span>
      default:
        return <span class='badge bg-warning'>Testperiod ({user.billable?.membership} dagar kvar)</span>
    }
  }

  const initials = name => {
    if (!name) return '?'
    return name
      .split(' ')
      .map(part => part[0])
      .slice(0, 2)
      .join('')
      .toUpperCase()
  }

  const type = data => {
    switch (data) {
      case 'App\\Notifications\\TenantNewComment':
        return <i class='fas fa-user-circle' />
      case 'App\\Notifications\\JobAttention':
        return <i class='far fa-eye' />
      case 'App\\Notifications\\JobSuccess':
        return <i class='fas fa-clock' />
      case 'App\\Notifications\\TenantNewTicket':
        return <i class='fas fa-envelope-open-text' />
      default:
        return <i class='fas fa-exclamation-circle' />
    }
  }

  const typeClass = data => {
    switch (data) {
      case 'App\\Notifications\\TenantNewComment':
        return 'notification-type-comment'
      case 'App\\Notifications\\JobAttention':
        return 'notification-type-attention'
      case 'App\\Notifications\\JobSuccess':
        return 'notification-type-success'
      case 'App\\Notifications\\TenantNewTicket':
        return 'notification-type-ticket'
      default:
        return 'notification-type-default'
    }
  }

  return (
    <>
    <ul class='navbar-nav navbar-user'>
      <li class='nav-item notifications'>
        <button class='nav-link' onClick={() => setNotificationsOpen(true)}>
          {notifications.unread > 0 ? (
            <span class='fa-stack has-badge' data-count={notifications.unread}>
              <i class='fa fa-bell fa-stack-1x' />
            </span>
          ) : (
            <span class='fa-stack'>
              <i class='fa fa-bell fa-stack-1x' />
            </span>
          )}
        </button>
      </li>
      <li class='nav-item'>
        <button class='nav-link' onClick={() => setUserMenuOpen(true)}>
          <span class='fa-stack'>
            <i class='fa fa-user fa-stack-1x' />
          </span>
        </button>
      </li>
      {billable?.membership !== -2 && !billable?.manual_sub && billable?.membership != null && !billable?.has_payment_method && (
        <li class='nav-item' style={{ display: 'flex', alignItems: 'center' }}>
          <a
            class='membership-cta'
            href='#!/setting/membership'
          >
            <i class='fas fa-money-check-alt' />
            <span>Aktivera abonnemang</span>
          </a>
        </li>
      )}
    </ul>
    <Drawer
      rootClassName='notifications-drawer'
      placement='right'
      open={notificationsOpen}
      closable={true}
      onClose={() => setNotificationsOpen(false)}
      width={420}
      title={
        <div class='notifications-title'>
          <span class='notifications-title-text'>Notiser</span>
          {notifications?.notifications?.length > 0 && (
            <span class={`notifications-count ${notifications.unread > 0 ? 'notifications-count-unread' : ''}`}>
              {notifications.unread > 0 ? `${notifications.unread} olästa` : 'Alla lästa'}
            </span>
          )}
        </div>
      }>
      {notifications?.notifications?.length > 0 && (
        <div class='notifications-toolbar'>
          {notifications.unread > 0 ? (
            <button class='notifications-mark-read' onClick={() => markAllAsRead()}>
              <i class='fas fa-check-double' />
              <span>Markera alla som lästa</span>
            </button>
          ) : (
            <span class='notifications-all-read'>
              <i class='fas fa-check-double' />
              <span>Alla notiser lästa</span>
            </span>
          )}
          <button class='notifications-clear' onClick={() => remove()}>
            <i class='far fa-trash-alt' />
            <span>Rensa alla</span>
          </button>
        </div>
      )}
      {!notifications?.notifications?.length ? (
        <div class='notification-empty'>
          <i class='fas fa-bell' />
          <span>Just nu har du inga notifikationer, allt verkar vara i ordning!</span>
        </div>
      ) : (
        notifications?.notifications?.map(notification => (
          <div
            key={notification.id}
            class={`notification-item ${notification.read_at === null ? 'notification-unread' : ''}`}
            onClick={() => {
              markAsRead(notification)
              if (notification.data.link === undefined) return
              setNotificationsOpen(false)
              window.location = notification.data.link
            }}>
            <span class={`notification-type ${typeClass(notification.type)}`}>{type(notification.type)}</span>
            <div class='notification-content'>
              <b>
                <span class='notification-title'>{notification.data.title}</span>
              </b>
              <p class='notification-body'>{notification.data.body}</p>
              <small class='text-muted'>{date.full(notification.created_at)}</small>
            </div>
            <a class='clear-notification' onClick={e => clearNotification(e, notification)}>
              <i class='fas fa-times' />
            </a>
          </div>
        ))
      )}
    </Drawer>
    <Drawer
      rootClassName='user-drawer'
      placement='right'
      open={userMenuOpen}
      closable={true}
      onClose={() => setUserMenuOpen(false)}
      width={360}
      title='Konto'>
      <div class='user-profile'>
        <div class='user-avatar'>{initials(user.name)}</div>
        <div class='user-meta'>
          <span class='user-name'>{user.name}</span>
          <span class='user-company'>{user.billable?.name}</span>
        </div>
        <div class='user-subscription'>{getSubscription()}</div>
      </div>
      <div class='user-menu'>
        <a class='user-menu-item' href='#!/setting/user' onClick={() => setUserMenuOpen(false)}>
          <span class='user-menu-icon user-menu-icon-profile'>
            <i class='fas fa-fw fa-user' />
          </span>
          <span class='user-menu-label'>Profil</span>
          <i class='fas fa-chevron-right user-menu-arrow' />
        </a>
        <a class='user-menu-item' href='#!/setting/membership' onClick={() => setUserMenuOpen(false)}>
          <span class='user-menu-icon user-menu-icon-membership'>
            <i class='fas fa-fw fa-money-check-alt' />
          </span>
          <span class='user-menu-label'>Abonnemang</span>
          <i class='fas fa-chevron-right user-menu-arrow' />
        </a>
        <div class='user-menu-divider' />
        <button class='user-menu-item user-menu-logout' onClick={() => Logout()}>
          <span class='user-menu-icon user-menu-icon-logout'>
            <i class='fas fa-fw fa-sign-out-alt' />
          </span>
          <span class='user-menu-label'>Logga ut</span>
          <i class='fas fa-chevron-right user-menu-arrow' />
        </button>
      </div>
    </Drawer>
    </>
  )
}
